var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 272,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 272",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.09961089 45.522179 125.80856011-44.82490273 129.195331 44.02801553-20.918288 166.4498052-108.277043 59.965759-106.5836574-59.168872z",
    fill: "#e23237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m255.103502 44.7252918-129.195331-44.02801553v270.44357973l108.277043-59.866148z",
    fill: "#b52e31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m126.107393 32.27393-78.3937743 174.418677 29.2856031-.498054 15.7385214-39.346304h33.4692608.099611 36.75642l17.232685 39.844358 27.990661.498054zm.199222 55.881712 26.496498 55.383658h-25.400778-1.294942-23.109728z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.5de8a0b112e415ba187a08415e7582be.svg";
export { ForwardRef as ReactComponent };